export default __webpack_public_path__ + "static/media/md-card-bg-Tableau.3159a012.png";